<template>
  <div class="content">
    <div class="md-layout mobile-compact">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card class="md-card-plain">
          <md-card-header data-background-color="green">
            <h4 class="title">
              Shortcuts
            </h4>
            <p class="category">
              List of all shortcuts
            </p>
          </md-card-header>
          <md-card-content
            class="mobile-compact"
            style="position: relative"
          >
            <md-button
              class="md-raised md-primary"
              to="/shortcut/new"
            >
              New Shortcut
            </md-button>
            <shortcuts-table :key="componentKey" />
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
    import {ShortcutsTable} from "@/components";

    export default {
        name: "ShortcutsPage",
        components: {
            ShortcutsTable,
        },
        data() {
            return {
                componentKey: 0,
                showNodeDialog: false,
                node: {
                    protocol: "",
                    ip: "",
                    serverAddress: "",
                    port: 0,
                    secret: "",
                    settings: "",
                    os: "",
                    location: {
                        longitude: "",
                        latitude: "",
                        countryCode: ""
                    },
                    capacity : 0,
                    //TODO:
                    tags: []
                }
            };
        },
        mounted() {

        },
        methods: {
            toggleNodeDialog() {
                this.showNodeDialog = !this.showNodeDialog;
            }
        }
    };
</script>

<style>
    @media only screen
    and (max-width: 850px)
    {
        .mobile-compact {
            padding: 0 !important;
        }
    }
    @-webkit-media only screen and (max-width: 850px) {
        .mobile-compact {
            padding: 0 !important;
        }
    }
</style>
